import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import styled from "styled-components";
import CustomerInformation from "./CustomerInformation";
import CarInformation from "./CarInformation";
import Payments from "./Payments";
import { useGetCustomerAttachmentQuery } from "../../utils/customerAttachment.utils";
import { moneyReceiptFormatter } from "../../utils/moneyReceipt.utils";
import Button from "../../ui/Button";
import { EditIcon } from "../../utils/icon.utils";
import CustomerAgreement from "./CustomerAgreement";
import { useGetRouteState } from "../../utils/route.utils";
import CustomerLoanInformation from "./CustomerLoanInformation";
import MoneyReceiptPrint from "./MoneyReceiptPrint";
import { useQueryParams } from "../../utils/queryParams.utils";
import MoneyReceiptOthersPrint from "./MoneyReceiptOthersPrint";
import DeliveryInformation from "./DeliveryInformation";

export default function MoneyReceiptViewPage() {
  const { fullPath } = useQueryParams();
  const { redirectTo } = useGetRouteState();

  const navigate = useNavigate();
  const { caid } = useParams();

  const { loading, data } = useGetCustomerAttachmentQuery({
    query: `?caid=${caid}`,
    options: {
      enabled: !!caid
    },
    key: `MoneyReceiptView-${caid}`
  });

  let formattedData = moneyReceiptFormatter(data);

  const breadCrumbs = [
    {
      name: "Money Receipt",
      link: redirectTo ?? "/money-receipt-list"
    },
    {
      name: loading ? "Loading..." : caid
    }
  ];

  const isLoading = loading;

  // handle edit
  const onEdit = (data) => {
    navigate(`/money-receipt-list/${data?.caid}/edit`, {
      state: { data, redirectTo: fullPath }
    });
  };

  return (
    <PageLayout
      style={{ hasCardBg: false, pageLayoutClassName: "pt-4", cardBodyClass: "p-0" }}
      title={isLoading ? "Loading..." : caid}
      breadCrumbs={breadCrumbs}>
      <Loading loading={isLoading} />
      {isLoading ? (
        "Loading..."
      ) : (
        <div className="row g-3 flex-column-reverse flex-md-row">
          <div className="col-12 col-md-4">
            <div className="row  g-3">
              <div className="col-12">
                <DeliveryInformation data={formattedData} />
              </div>
              <div className="col-12">
                <CustomerAgreement data={formattedData} />
              </div>
              <div className="col-12">
                <CustomerLoanInformation data={formattedData} />
              </div>
              <div className="col-12">
                <CustomerInformation data={formattedData} />
              </div>
              <div className="col-12">
                <CarInformation data={formattedData} />
              </div>
              <div className="col-12 mb-3">
                <div className="text-center">
                  <Button
                    onClick={() => onEdit(formattedData)}
                    name="Edit Money Receipt"
                    icon={EditIcon}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-8">
            <div className="row g-3">
              <div className="col-12">
                <Payments data={formattedData} />
              </div>
              <div className="col-12">
                <MoneyReceiptPrint data={formattedData} />
              </div>
              <div className="col-12">
                <MoneyReceiptOthersPrint data={formattedData} />
              </div>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
}

export const SkuContainer = styled.p`
  font-size: 0.9rem;
  color: rgb(var(--primary) / 0.8);
  transition: color 0.3s ease;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    color: rgb(var(--primary) / 1);
  }
`;

export const TitleContainer = styled.p`
  font-size: 1.2rem;
  color: rgb(var(--dark) / 1);
  transition: color 0.3s ease;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: rgb(var(--primary) / 1);
  }
`;

export const OverviewContainer = styled.ul`
  li:last-of-type {
    border-bottom: 0 !important;
  }
`;
